<div class="text-center">
    <div class="text-center">
        <h4 class="montserrat-bold text-uppercase text-gray-500 mb-4">Attention</h4>
        {{ getDescription() }}
    </div>
</div>
<div class="d-flex align-items-center justify-content-center mt-4">
    <button class="btn btn-md btn-outline-gray-500 mr-3" mat-dialog-close>Cancel</button>
    <button class="btn btn-md btn-gray-500 mr-3" (click)="performAction()">Confirm</button>
</div>
